module.exports = __webpack_public_path__ + "img/powered-black.33d65000.svg";